import * as React from 'react';
import '../css/channel-card.sass';
import Card from './Card';
import RAPPopup from './RAPPopup';

interface ChannelCardProps {
  imageUrl?: string;
  name: string;
  label?: string;
  number?: string;
  resolution?: string;
  description?: string;
  theme?: 'night' | 'day';
}

interface ChannelCardState {
  showPopup: boolean;
}

export default function ChannelCard(props: ChannelCardProps) {
  const [state, setState] = React.useState<ChannelCardState>({
    showPopup: false
  });
  const { label = 'CH', theme = 'day' } = props;
  const isMobileView = window.innerWidth < 992;
  const channelCard = (
    <>
      {props.imageUrl && (
        <>
          <img className="ch-logo" alt="" src={props.imageUrl} />
          <div className="divider" />
        </>
      )}
      <div className="ch-name">{props.name}</div>
      {(props.number || props.resolution) && (
        <div className="ch-detail">
          {props.number && (
            <span className="ch-number">{`${label} ${props.number}`}</span>
          )}
          {props.resolution && (
            <span className="ch-resolution">{props.resolution}</span>
          )}
        </div>
      )}
      {isMobileView && !state.showPopup ? (
        <button
          type="button"
          id={`${props.name.replace(/[^\w]/g, '')}Btn`}
          onClick={() => {
            setState({ ...state, showPopup: true });
          }}
        />
      ) : (
        props.description && (
          <div className="ch-description">{props.description}</div>
        )
      )}
    </>
  );

  return (
    <div
      className={`channel-card ${theme}${state.showPopup ? ' takeover' : ''}`}
    >
      {state.showPopup ? (
        <RAPPopup
          toggleRAP={state.showPopup}
          onClose={() => {
            setState({ ...state, showPopup: false });
          }}
        >
          {channelCard}
        </RAPPopup>
      ) : (
        <Card theme={theme}>{channelCard}</Card>
      )}
    </div>
  );
}
